import React, { useEffect } from "react";
import {
  Modal,
  Button,
  Group,
  Text,
  Stack,
  Title,
  List,
  ThemeIcon,
} from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import { nonProtectedRoutes } from "../../../utils/nonProtectedRoutingPaths";
import Cookies from "js-cookie";

export const PricingModal = ({ opened, onClose }) => {
  const MODAL_COOKIE_NAME = "pricing-modal-dismissed";

  useEffect(() => {
    if (opened && Cookies.get(MODAL_COOKIE_NAME) === "true") {
      onClose();
    }
  }, [opened, onClose]);

  const handleStartFreeTrial = () => {
    Cookies.remove(MODAL_COOKIE_NAME);
    window.location.href = nonProtectedRoutes.REGISTER;
  };

  const handleSelectPlan = () => {
    // day
    Cookies.set(MODAL_COOKIE_NAME, "true", { expires: 1 });
    window.location.href = nonProtectedRoutes.PRICING;
  };

  return (
    <Modal
      opened={opened && Cookies.get(MODAL_COOKIE_NAME) !== "true"}
      onClose={onClose}
      centered
      radius="lg"
      size="lg"
      overlayProps={{
        blur: 3,
        opacity: 0.55,
      }}
      withCloseButton={false}
      styles={{
        content: {
          boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <Stack p="lg">
        <Title order={3} c="dark.7">
          Try Socius Legal for Free
        </Title>

        <Text size="md" c="gray.7" mb="xs">
          Get{" "}
          <Text span fw={700} c="var(--primary-color)">
            5 free requests
          </Text>{" "}
          to experience the power of AI-driven legal drafting - no commitment
          required. After your free trial, you can choose a plan that fits your
          needs.
        </Text>

        <List spacing="xs" size="md" center mb="md">
          <List.Item
            icon={
              <ThemeIcon color="var(--primary-color)" size={24} radius="xl">
                <IconCheck size={16} />
              </ThemeIcon>
            }
          >
            Generate contracts, research memos, and more in seconds
          </List.Item>

          <List.Item
            icon={
              <ThemeIcon color="var(--primary-color)" size={24} radius="xl">
                <IconCheck size={16} />
              </ThemeIcon>
            }
          >
            AI-powered legal expertise built for lawyers
          </List.Item>

          <List.Item
            icon={
              <ThemeIcon color="var(--primary-color)" size={24} radius="xl">
                <IconCheck size={16} />
              </ThemeIcon>
            }
          >
            Simple, secure, and seamlessly integrated into your workflow
          </List.Item>
        </List>

        <Group mt="sm">
          <Button
            size="lg"
            radius="md"
            color="var(--primary-color)"
            onClick={handleStartFreeTrial}
            fullWidth
            styles={{
              root: {
                fontWeight: 700,
                boxShadow: "0 4px 14px rgba(229, 160, 70, 0.3)",
                transition: "all 0.2s ease",
                "&:hover": {
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 20px rgba(186, 131, 58, 0.3)",
                },
              },
            }}
          >
            START YOUR FREE TRIAL
          </Button>

          <Button
            variant="subtle"
            color="gray"
            onClick={handleSelectPlan}
            fullWidth
            styles={{
              root: {
                fontStyle: "italic",
              },
            }}
          >
            (or select a plan now)
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default PricingModal;
